// Client-safe utility functions
import { logSecurity as _logSecurity, logError as _logError } from '../lib/logger';

export function getRandomDigits(len: number): string {
    const max = Math.pow(10, len) - 1;
    const randomNum = Math.floor(Math.random() * (max + 1));
    return String(randomNum).padStart(len, '0');
}

export function logSecurity(str: string): void {
    _logSecurity(str);
}

export function logError(str: string): void {
    _logError(str);
}

export function getLastUsedEmail(): string | undefined {
    if (typeof document === 'undefined') return undefined;
    const match = document.cookie.match(/(?:^|;\s*)email=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : undefined;
}
